import { CampaignBannerViewModel } from '@api/models/CampaignBannerViewModel';

export const getDataProps = (
  xl: boolean,
  color: string,
  campaignData?: CampaignBannerViewModel
) => {
  return {
    imgSrc: campaignData?.images[0]?.url || '',
    id: campaignData?.id || '',
    mainText: campaignData?.title || '',
    secondText: campaignData?.boldTitle || '',
    description: campaignData?.subText || '',
    link: campaignData?.link?.[0]?.href || '',
    linkName: campaignData?.link?.[0]?.name || '',

    styles: {
      secondTextBottomMargin: 13,
      descTextBottomMargin: 27,
      mainTextFontSize: 26,
      descFontSize: 13,
      linTextSize: 14,
      fadeOutLayoutStyle: {
        display: 'none',
      },
      linkDescWrapperStyle: !xl
        ? {
            display: 'flex',
            flexDirection: 'column' as const,
            alignItems: 'center',
          }
        : {},
      textContainerStyles: xl
        ? {
            display: 'unset',
            flexDirection: 'unset' as const,
            width: 'unset',
            height: 'unset',
            justifyContent: 'unset',
            alignItems: 'unset',
            padding: '35px 80px',
          }
        : {},
      descriptionStyle: xl
        ? {
            margin: 'unset',
            width: '49.5%',
            textAlign: 'unset' as const,
            marginBottom: '27px',
          }
        : {},
      linkWrapperStyle: {
        padding: '9px 18px',
        maxWidth: '220px',
        color,
      },
    },
  };
};
